import { NgClass } from '@angular/common'
import { Component } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'formly-field-checkbox-field-type',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, NgClass, SvgIconComponent],
  templateUrl: './checkbox-field-type.component.html',
})
export class CheckboxFieldTypeComponent extends FieldType<FieldTypeConfig> {
  public toggleState(): void {
    const newValue = !this.formControl.value
    this.formControl.setValue(newValue)
    this.formControl.markAsDirty()
    this.formControl.markAsTouched()
  }

  public onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement
    this.formControl.setValue(target.checked)
  }
}
